// extracted by mini-css-extract-plugin
export var actionText = "_si-4";
export var container = "_si-0";
export var leftSection = "_si-1";
export var rightSection = "_si-2";
export var settingsButton = "_si-6";
export var settingsIcon = "_si-7";
export var shortcut = "_si-5";
export var shortcutGroup = "_si-3";